export class ApplicationSubjectPropertyApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getSubjectProperty({ applicationId }) {
    return this.#http.get(`/application/${applicationId}/subjectproperty`);
  }

  async editSubjectPropertyObsolete({
    applicationId,
    reassignLoanOfficer,
    withLoanOptionId,
    ...body
  }) {
    return this.#http.put(`/application/${applicationId}/subjectproperty`, body, {
      params: { withLoanOptionId, reassignLoanOfficer },
    });
  }

  async editSubjectProperty({ applicationId, reassignLoanOfficer, withLoanOptionId, ...body }) {
    return this.#http.put(`/application/${applicationId}/subject-property/summary`, body, {
      params: { withLoanOptionId, reassignLoanOfficer },
    });
  }
}
